import "./ShipmentGroupReviewView.scss";
import React, { useContext } from "react";
import IVendorModel from "../../../../models/IVendorModel";
import IClient from "../../../../models/IClient";
import IOrder from "../../../../models/IOrder";
import INewAddress from "../../../../models/INewAddress";
import IShipment_GroupUI from "../../../../models/IShipment_GroupUI";
import OwButton from "../../../shared/OwButton/OwButton";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import * as _ from "lodash-es";
import AddressDisplay from "../../../shared/AddressDisplay/AddressDisplay";
import SupplierContext from "../../../../contexts/SupplierContext";
import UserContext from "../../../../contexts/UserContext";

type Props = {
    cancel: () => void;
    selectedVendor?: IVendorModel | IClient;
    selectedOrders: IOrder[];
    shipTo?: INewAddress;
    billTo?: INewAddress;
    shipmentGroup?: IShipment_GroupUI;
    headerTitle: string;
    changeView: (view: "create" | "review") => void;
    createInShipstation: boolean;
    isLocalPickup: boolean;
    isLocalDelivery: boolean;
    isDropshipment: boolean;
    activeCreateUpdateShipment: boolean;
    billToSameAsShipTo: boolean;
    updateShipmentGroup: () => void;
    createShipmentGroup: () => void;
};

export const ShipmentGroupReviewView = (props: Props) => {
    const supplierModel = useContext(SupplierContext);
    const userModel = useContext(UserContext);

    return (
        <div className={"ShipmentGroupReviewView p-3"}>
            <div>
                <div className="text-end">
                    <OwButton
                        fn={() => {
                            props.cancel();
                        }}
                        title={""}
                        centerIconClass={"far fa-times"}
                        className={"btn-danger"}
                    />
                </div>
                <OwTitle leftIconName={"fas fa-truck"} title={props.headerTitle} />
                {/*<h2><i className="fas fa-truck"></i> {header}</h2>*/}
                <hr />
            </div>

            <div className="review-section">
                <div>
                    <OwLabel title={"vendor"} isSupplierVendorOverride={true} supplierModel={supplierModel} isBold={true} />
                    <div className="ms-3">{_.get(props, "selectedVendor.name", "")}</div>
                </div>
                <div>
                    <OwLabel title={"order_ids"} isBold={true} />
                    <div className="ms-3">
                        {!_.isNil(props.selectedOrders) &&
                            props.selectedOrders.map((order, index) => {
                                return <div key={index}>{order.name}</div>;
                            })}
                    </div>
                </div>
                {props.isLocalPickup ? null : (
                    <div>
                        <OwLabel title={"ship_to"} isBold={true} />
                        <div className={"ms-3"}>
                            <AddressDisplay showName={true} showCompanyName={true} address={props.shipTo} />
                        </div>
                    </div>
                )}
                {props.isLocalPickup || props.billToSameAsShipTo ? null : (
                    <div>
                        <OwLabel title={"bill_to"} isBold={true} />

                        {/*{this.getBillToView()}*/}
                    </div>
                )}

                <div>
                    <OwLabel title={"is_dropshipment"} postText={":"} className={"me-2"} isBold={true} />
                    {props.isDropshipment ? <OwLabel title={"yes"} /> : <OwLabel title={"no"} />}
                </div>

                {supplierModel.has_local_pickup ? (
                    <div>
                        <OwLabel title={"is_local_pickup"} postText={":"} className={"me-2"} isBold={true} />
                        {props.isLocalPickup ? <OwLabel title={"yes"} /> : <OwLabel title={"no"} />}
                    </div>
                ) : null}

                {supplierModel.has_local_delivery ? (
                    <div>
                        <OwLabel title={"is_local_delivery"} postText={":"} className={"me-2"} isBold={true} />
                        {props.isLocalDelivery ? <OwLabel title={"yes"} /> : <OwLabel title={"no"} />}
                    </div>
                ) : null}

                {supplierModel.Supplier_Integration.has_shipstation &&
                !props.shipmentGroup?.shipstation_order_key &&
                !props.shipmentGroup?.guid ? (
                    <div className={"mb-2"}>
                        <OwLabel title={"create_in_shipstation"} postText={":"} isBold={true} className={"me-2"} />
                        {props.createInShipstation ? <OwLabel title={"yes"} /> : <OwLabel title={"no"} />}
                    </div>
                ) : null}

                <div className={"mb-4 "}>
                    <OwButton
                        className={"btn-danger me-3"}
                        leftIconClass={"fas fa-pencil"}
                        title={"edit"}
                        fn={() => {
                            props.changeView("create");
                        }}
                    />

                    {
                        <OwButton
                            disabled={props.activeCreateUpdateShipment}
                            active={props.activeCreateUpdateShipment}
                            leftIconClass={"fas fa-save"}
                            title={"save"}
                            fn={() => {
                                if (!_.isNil(props.shipmentGroup) && props.shipmentGroup.guid) {
                                    props.updateShipmentGroup();
                                } else {
                                    props.createShipmentGroup();
                                }
                            }}
                        />
                    }
                </div>
            </div>
        </div>
    );
};
